const state = {
    progress: 0,  
    isProgressBarVisible: false,
}

const mutations = {
  updateProgress(state, newValue) {  
    state.progress = newValue;  
  },  
  updateProgressVisible(state, newValue) {  
    state.isProgressBarVisible = newValue;  
  },  

  showProgress() {  
    state.progress = 0;  
    state.isProgressBarVisible = true;  
  },
  hideProgress() {
    state.progress = 0;  
    state.isProgressBarVisible = false;
  }
}


export default {
    namespaced: true,
    state,
    mutations
}